'use strict';

var swiperEls = {};
function initSwiper() {
    const windowWidth = $(window).width();
    var optionDefault = {
        spaceBetween: 0,
        slidesPerView: 2.5,
        preloadImages: false,
        loop: false,
        centeredSlides: false,
        loopedSlides: 2,
        a11y: false,
        enabled: false,
        breakpoints: {
            769: {
                enabled: true,
                slidesPerView: 4
            }
        }
    }

    const elm = $('.swiper-container-store.js-store-swiper');
    var isPageTml = $('section').hasClass('page_tmlmwwm');
    var isPageDespres = $('section').hasClass('page_despres');
    if (isPageTml || isPageDespres) {
        optionDefault.breakpoints = {
            769: {
                enabled: true,
                slidesPerView: 5
            }
        }
    }

    elm.each((index, element) => {
        const elementId = $(element).data('id');
        var isNewArrival = $(element).hasClass('new-arrival-top');
        var isPageGalerievieNews = $(element).hasClass('store-galerievie');
        if (isNewArrival) {
            optionDefault.spaceBetween = 2
            optionDefault.pagination = {
                el: '.swiper-container-store .swiper-pagination',
                clickable: true
            }
            optionDefault.breakpoints = {
                769: {
                    enabled: true,
                    slidesPerView: 5
                }
            }
        }
        if (isPageGalerievieNews) {
            optionDefault.slidesPerView = 1;
            optionDefault.loop = true;
            optionDefault.pagination = {
                el: '.swiper-container-store .swiper-pagination',
                clickable: true
            }
            optionDefault.breakpoints = {
                769: {
                    enabled: true,
                    slidesPerView: 2,
                    slidesPerGroup: 2
                }
            }
        }
        // Destroy swiper if applicable
        if (swiperEls[elementId]) {
            swiperEls[elementId].destroy();
        }
        var isTopicJamesperse = $(element).hasClass('store-jamesperse');
        var isNewJamesperse = $(element).hasClass('store-jamesperse-new');
        var isGender = $(element).hasClass('gender-items');

        if (isGender) {
            optionDefault.breakpoints = {
                769: {
                    spaceBetween: 10,
                    enabled: true,
                    slidesPerView: 5
                }
            }
        }

        if (isTopicJamesperse || isNewJamesperse) {
            optionDefault.spaceBetween = 0;
            optionDefault.breakpoints = {
                769: {
                    enabled: true,
                    spaceBetween: 10,
                    slidesPerView: 2,
                    slidesPerGroup: 1
                }
            };
            optionDefault.pagination = {
                el: '.swiper-container-store .swiper-pagination',
                clickable: true
            }
        }

        optionDefault.navigation = {
            nextEl: '.next-button-' + elementId,
            prevEl: '.prev-button-' + elementId
        };

        if (elementId == "store-jamesperse" || elementId == "store-jamesperse-new") {
            optionDefault.loop = true;
        }

        // init swiper when page load or resize window
        swiperEls[elementId] = new Swiper('.' + elementId, optionDefault);

        if (isPageTml) {
            const prevarrow = $('.prev-button-' + elementId)[0];
            const nextarrow = $('.next-button-' + elementId)[0];
            prevarrow.style.display = 'none';
            nextarrow.style.display = 'none';
            var itemNextPrev = optionDefault.breakpoints['769'].slidesPerView;

            if (swiperEls[elementId].slides.length > itemNextPrev) {
                nextarrow.style.display = 'block';
            }

            swiperEls[elementId].on('slideChange', function () {
                const realIndex = swiperEls[elementId].realIndex;
                const activeIndex = swiperEls[elementId].slides.length - itemNextPrev;
                realIndex == 0 ? prevarrow.style.display = 'none' : prevarrow.style.display = 'block';
                realIndex == activeIndex ? nextarrow.style.display = 'none' : nextarrow.style.display = 'block';
            });
        }
    });
}

$(document).ready(function(){
    initSwiper();
});

$(window).resize(function () {
    initSwiper();
});
